import { Component, EventEmitter, Input, Output, TemplateRef, model, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BtnComponent } from 'ets-fe-ng-sdk';
import { toObservable, toSignal } from '@angular/core/rxjs-interop';
import { tap } from 'rxjs';

@Component({
    selector: 'print-case',
    templateUrl: './print-case.component.html',
    styleUrls: ['./print-case.component.scss'],
    imports: [CommonModule, BtnComponent]
})
export class PrintCaseComponent {
  @Input() actualContent: TemplateRef<any>;
  @Input({ required: true }) printContent: TemplateRef<any>;
  @Input() btnText: string = 'Export To PDF';
  readonly isPrintMode = model(false);
  readonly disableExport = signal<boolean>(false);
  readonly showBackBtn = signal<boolean>(true);
  @Input('disableExport') set _disableExport(disableExport: boolean) {
    this.disableExport.set(disableExport);
  }
  @Input('showBackBtn') set _showBackBtn(showBackBtn: boolean) {
    this.showBackBtn.set(showBackBtn);
  }
  @Output() viewSwitch = new EventEmitter<{ isPrintMode: boolean }>();
  @Output() backToActualContent = new EventEmitter<boolean>();

  readonly checkMode = toSignal(
    toObservable(this.isPrintMode).pipe(
      tap((r) => {
        this.viewSwitch.emit({ isPrintMode: this.isPrintMode() });
        this.backToActualContent.emit(!this.isPrintMode());
      }),
    ),
  );

  setAsViewMode() {
    this.isPrintMode.set(false);
  }
  setAsPrintMode() {
    this.isPrintMode.set(true);
  }
}
